import { css, cx } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
interface NoteProps {
    /** @deprecated */
    style?: React.CSSProperties;
    checkboxNote?: boolean;
    /** @deprecated */
    className?: string;
    heading?: string;
    children?: React.ReactNode;
}
export function Note({ heading, children, style, checkboxNote, className }: NoteProps) {
    const customStyle = checkboxNote ? { style, display: "block" } : style;
    return (<div>
            <p className={noteHeaderStyles}>{heading}</p>
            <div className={cx(noteStyles, className)} style={customStyle}>
                {children}
            </div>
        </div>);
}
export default Note;
const noteStyles = css({
    font: text.body.regular.xSmall,
    textAlign: "left",
    marginBottom: space[8],
    color: themeTokens.color.text.tertiary,
    // TODO temporary fix for link color
    // We are planning to deprecate this component in the future
    a: {
        color: themeTokens.color.text.link.default,
    },
});
const noteHeaderStyles = css({
    font: text.body.bold.xSmall,
    color: themeTokens.color.text.tertiary,
    margin: 0,
});
